<mds-card [appearance]="'elevated'">
    <mds-card-content>
        <div class="p-medpace flex flex-col gap-medpace">
            @if (requestsCount()) {
                <div class="flex flex-row justify-between">
                    <h3>Requests Overview</h3>
                    <mds-button
                        [id]="'allRequestsBtn'"
                        (clickEvent)="goToTable()"
                        label="View all requests"
                        [variant]="'tonal'"
                        color="primary"
                    ></mds-button>
                </div>

                <div class="grid grid-cols-5 gap-4 pl-10">
                    <h5>Travel Requests</h5>
                    <span class="col-span-3 col-start-3">{{ travelCount() }}</span>
                    <h5>Reimbursement Requests</h5>
                    <span class="col-span-3 col-start-3">{{ reimbursementCount() }}</span>
                    <h5>Stipend Requests</h5>
                    <span class="col-span-3 col-start-3">{{ stipendCount() }}</span>
                </div>
            } @else {
                <medpace-loading></medpace-loading>
            }
        </div>
    </mds-card-content>
</mds-card>
